import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=65cdf29d&scoped=true"
import script from "./parameter.vue?vue&type=script&lang=js"
export * from "./parameter.vue?vue&type=script&lang=js"
import style0 from "./parameter.vue?vue&type=style&index=0&id=65cdf29d&prod&scoped=true&lang=css"
import style1 from "./parameter.vue?vue&type=style&index=1&id=65cdf29d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdf29d",
  null
  
)

export default component.exports